import axios from "axios";
import { API_ENDPOINT } from "../../common/constants/apiConstants";

export const getSettings = async () => {
  const url = API_ENDPOINT.SETTINGS.GET_ALL_SETTINGS;
  try {
    const response = await axios.get(url);
    return response.data;
  } catch (error) {
    console.error("Get settings API Failed:", error);
    throw error.response?.data || { message: "Network error" };
  }
};

export const updateSettings = async (payload) => {
  const url = API_ENDPOINT.SETTINGS.UPDATE_SETTINGS;
  try {
    const response = await axios.post(url, payload);
    return response.data;
  } catch (error) {
    console.error("Update settings API Failed:", error);
    throw error.response?.data || { message: "Network error" };
  }
};
